import Icon from '../components/Icon.vue'

Icon.register({
  car: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M500 176H440.1L423.5 134.4C406.4 91.6 365.6 64 319.5 64H192.5C146.4 64 105.6 91.6 88.5 134.4L71.9 176H12C4.2 176-1.5 183.3 0.4 190.9L6.4 214.9C7.7 220.3 12.5 224 18 224H38.1C24.6 235.7 16 252.8 16 272V320C16 336.1 22.2 350.7 32 361.9V416C32 433.7 46.3 448 64 448H96C113.7 448 128 433.7 128 416V384H384V416C384 433.7 398.3 448 416 448H448C465.7 448 480 433.7 480 416V361.9C489.8 350.7 496 336.1 496 320V272C496 252.8 487.4 235.7 473.9 224H494C499.5 224 504.3 220.3 505.6 214.9L511.6 190.9C513.5 183.3 507.8 176 500 176zM147.9 158.2C155.2 139.9 172.9 128 192.5 128H319.5C339.1 128 356.8 139.9 364.1 158.2L384 208H128L147.9 158.2zM96 319.8C76.8 319.8 64 307 64 287.9S76.8 256 96 256 144 284.7 144 303.9 115.2 319.8 96 319.8zM416 319.8C396.8 319.8 368 323 368 303.9S396.8 256 416 256 448 268.8 448 287.9 435.2 319.8 416 319.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/car.js
// module id = vanS
// module chunks = 144